import { BaseComponent } from "./BaseComponent";
import { HostListener } from "@angular/core";

/**
 * Extend this class if you need a infinite scroll behaviour
 * 
 */

export abstract class InfiniteScrollComponent extends BaseComponent {

  previousScrollY:number = -1;
  resultsEndReached: boolean = false;
  isLoading: boolean = false;
  showScrollToTopButton: boolean = false;

  offset: number = 0;
  limit: number = 18;

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {

    //Verify that we scroll vertically, not horizontally
    if(window.scrollY != this.previousScrollY){

      this.previousScrollY = window.scrollY;
      let distanceFromBottom = document.body.scrollHeight - window.innerHeight - window.scrollY;
      let shouldReload = distanceFromBottom <= 400;

      if(shouldReload && !this.isLoading && !this.resultsEndReached) {
        this.loadMoreItems();
      }

    }
 
    this.showScrollToTopButton = (window.scrollY > 500);
  }

  abstract loadMoreItems();

}